import React from 'react';
import { Box } from '@mui/material';
import { APP_HEADER_HEIGHT } from './layoutConstants';

/**
 * Fixed-height main column below AppHeader.
 * Outer shell clips overflow; inner area scrolls so the document does not bounce on overscroll.
 */
export default function MainContentScrollArea({
  children,
  ml = 0,
  bgcolor = '#f3f2f5ff',
  sx,
  innerSx,
}) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        bgcolor,
        height: `calc(100vh - ${APP_HEADER_HEIGHT}px)`,
        mt: `${APP_HEADER_HEIGHT}px`,
        ml: typeof ml === 'number' ? `${ml}px` : ml,
        p: 0,
        overflow: 'hidden',
        transition: 'margin-left 0.2s ease',
        ...sx,
      }}
    >
      <Box
        data-main-scroll
        sx={{
          height: '100%',
          overflowY: 'auto',
          overscrollBehavior: 'none',
          ...innerSx,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
